import React from 'react';
import { classNames } from '@fullstory/util/fmt';
import { Box, BoxStyleSpaceScale, SpaceScale } from '@fullstory/components';
import css from './index.module.scss';
import colors from './colors.module.scss';

type ColorClasses = keyof typeof colors;
type StripedClasses = `${ColorClasses}-striped`;

type ColorOptions = {
  [P in ColorClasses]: P extends StripedClasses ? never : P;
}[ColorClasses];

export interface SegmentDotProps {
  color?: ColorOptions;
  variant?: 'primary' | 'secondary' | 'outlined';
  padding?: SpaceScale | BoxStyleSpaceScale;
}

export const SegmentDot: React.FC<SegmentDotProps> = ({
  color,
  variant = 'primary',
  padding = [0, 12, 0, 0],
}) => {
  let colorClass = color ? colors[color] : '';
  const striped = variant === 'secondary';
  if (striped && color) colorClass = colors[`${color}-striped` as const];

  return (
    <Box data-component="SegmentDot" padding={padding}>
      <div
        data-testid="legend-dot"
        className={classNames(css.circle, colorClass, { [css.outlined]: variant === 'outlined' })}
      />
    </Box>
  );
};
